<script>
import Vue from 'vue'
import date from '../mixins/date'
import UserResource from '../resources/user'
import MessageResource from '../resources/message'
import { simpleSafeStringToHTML } from '../util/string'

export default Vue.extend({
    components: {},
    mixins: [date],
    props: {
        messageResource: {
            type: MessageResource,
            required: true
        },
        mine: Boolean
    },
    computed: {
        contentRich() {
            return simpleSafeStringToHTML(this.messageResource.attributes.content)
        },
        sentPretty() {
            return this.dateTimeRelative(new Date(this.messageResource.attributes.sent))
        }
    },
    data() {
        return {}
    },
    watch: {},
    methods: {
        getClasses() {
            let classes = []

            if(this.mine) {
                classes.push('mine')
            }

            return classes
        }
    },
    mounted() {
        
    }
})
</script>

<template>
<!--dateStringToDatePretty-->
    <b-col :class="getClasses()" sm="10" :offset="mine ? 2 : 0">
        <div class="message">
            <span v-html="contentRich" />
        </div>
        <div class="meta">
            Sent {{ sentPretty }}
        </div>
    </b-col>
</template>

<style lang="scss" scoped>
.message {
    padding: 10px 15px;
    background-color: rgb(241, 241, 241);
    width: 100%;
    border-radius: 20px;
    border: 1px solid #eaeaea;
    line-height: 20px;
    font-size: 0.9rem;
}

.meta {
    margin-bottom: 0.5rem;
    font-size: 0.7rem;
    color: #adadad;
}

.mine {
    .message {
        color: #fff;
        background-color: #008dce;
        border: none;
    }

    .meta {
        text-align: right;
    }
}

</style>
